<template>
  <export-excel
    type="csv"
    class="export_btn"
    :name="`Report_${volunteer.code}-${volunteer.name} (${$route.query.month}/${$route.query.year}).xls`"
    :fields="custom_fields"
    :fetch="getData"
    :footer="[
      `${volunteer.code}-${volunteer.name}`,
      `${$route.query.month}/${$route.query.year}`,
    ]"
  >
    <v-icon color="white" left>mdi-chevron-right-circle-outline</v-icon>Export
  </export-excel>
</template>

<script>
export default {
  props: {
    volDetail: {
      type: Array,
    },
    volunteer: {
      type: Object,
    },
  },
  computed: {},
  data: () => ({
    custom_fields: {
      No: "counter",
      အစီရင်ခံမည့်အချက်အလက်များ: "title",
      Male: {
        field: "data",
        callback: (value) => {
          return value.male != null ? value.male : "";
        },
      },
      Female: {
        field: "data",
        callback: (value) => {
          return value.female != null ? value.female : "";
        },
      },
      Total: {
        field: "data",
        callback: (value) => {
          return value.male != null && value.female != null
            ? parseInt(value.male) + parseInt(value.female)
            : value;
        },
      },
    },
  }),

  methods: {
    getData() {
      if (this.volDetail.length > 0) return this.volDetail;
    },
  },
};
</script>

<style scoped>
.export_btn {
  background: #ff4081;
  border-radius: 3px;
  color: white !important;
  letter-spacing: 1px;
  text-transform: uppercase;
  width: 120px;
  padding: 5px 15px;
  margin-bottom: 1px;
  cursor: pointer;
}
</style>
